/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetCloudResourceFilterValuesQuery } from "~/generated/graphql";

export const useGetCloudResourceFilterValues = () => {
  const { data, loading, error } = useGetCloudResourceFilterValuesQuery();

  return { data, loading, error } as const;
};
